module.exports = __webpack_public_path__ + "img/no-image-vivo-ligado.66585b60.jpg";